import { Button, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

export default function CheckInOutModal({
  show,
  onHide,
  onConfirm,
  isCheckIn,
  volunteerName,
  disabled = false,
}) {
  const { t } = useTranslation()

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {isCheckIn
            ? t('VolunteerListScreen.check_in_title', 'Volunteer Check In {{name}}', {
                name: volunteerName,
              })
            : t(
                'VolunteerListScreen.check_out_title',
                'Volunteer Certification of Completion {{name}}',
                { name: volunteerName },
              )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isCheckIn
          ? t(
              'VolunteerListScreen.check_in_details',
              'A Check In timestamp will be created for this user.',
            )
          : t(
              'VolunteerListScreen.check_out_details',
              'A Check Out timestamp will be created for this user.',
            )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t('VolunteerListScreen.cancel_label', 'Cancel')}
        </Button>
        <Button 
          variant="primary" 
          disabled={disabled}
          onClick={(e) => {
            // prevent double-click/double-firing
            if (disabled) {
              e.preventDefault()
              e.stopPropagation()
              return
            }
            e.preventDefault()
            e.stopPropagation()
            if (onConfirm) {
              onConfirm()
            }
          }}
        >
          {isCheckIn
            ? t('VolunteerListScreen.check_in_button', 'Check In')
            : t('VolunteerListScreen.check_out_button', 'Check Out')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

